package navigation.utils

import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.tab.Tab
import com.essntl.uikit.components.link.NavLinkState

interface NavLinkScreen : Screen {
    val defaultTitle: String

    val navLinkState: NavLinkState get() = NavLinkState(title = defaultTitle)
}

interface NavLinkTab : Tab {
    val innerNavigator: Navigator?
}